// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".content-teaser-landscape .heading[data-v-4e5dd8c5]{margin-bottom:.75em}.content-teaser-landscape a.img[data-v-4e5dd8c5]{display:block}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
